import { InjectionToken } from '@angular/core';

export const GRAPHQL_API_URL = new InjectionToken<string>('GRAPHQL_API_URL');
